import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import Helmet from 'react-helmet';
import {Link} from 'react-router-dom';
import PlusCircle from 'react-feather/dist/icons/plus-circle.js';

import DefaultLayout from '../Layout/DefaultLayout.jsx';
import Header from '../../components/Header/Header.jsx';
import OfferExampleCard from '../../components/OfferExample/Card/OfferExampleCard.jsx';
import OfferExampleDetail from '../../components/OfferExample/Detail/OfferExampleDetail.jsx';
import OfferExampleModal from '../../components/Modals/OfferExampleModal/OfferExampleModal.jsx';

import connectModal from '../../../shared/components/Modals/connect.js';
import {generate} from '../../routes.js';
import {redirectToNotFound} from '../Errors/actions.js';

import offersExamples from './offers-examples.json';

import './OffersExamples.scss';

class OffersExamples extends PureComponent {
  openModal = (offer) => {
    this.props.openOfferExampleModal({offer: offer});
  };

  render() {
    const {metaTitle, metaDescription, title, ...props} = this.props;

    const offers = offersExamples?.[props.universeCode]?.length ? offersExamples[props.universeCode] : []
      .filter(offer => offer.pageDetailPosition)
      .sort((first, second) => first.pageDetailPosition - second.pageDetailPosition);

    if (offers.length === 0) {
      props.redirectToNotFound();
    }

    const nbOffersPerGroup = 2;
    const detailedOffersGrouped = [];
    for (let i = 0; i < offers.length; i += nbOffersPerGroup) {
      detailedOffersGrouped.push(offers.slice(i, i + nbOffersPerGroup));
    }

    const ctas = [
      <Link key="ctas-01" className="btn btn-primary" to={generate({name: 'register-freelance'})}>Découvrir toutes nos missions</Link>,
      <Link key="ctas-02" className="btn btn-primary" to={generate({name: 'register-freelance'})}>Nous rencontrer</Link>,
      <Link key="ctas-03" className="btn btn-primary" to={generate({name: 'register-freelance'})}>Recevoir des missions</Link>
    ];

    const helmet = <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription}/>
      <meta property="og:description" content={metaDescription}/>
      <meta property="og:title" content={metaTitle}/>
    </Helmet>;

    return <DefaultLayout id="offers-examples" showSidebarMenu={false} helmet={helmet}>
      <Header
        brief={<p>Les missions suivantes ont toutes été proposées sur notre plateforme par le passé.</p>}
        title={title}
      />

      <section className="container text-center">
        {detailedOffersGrouped.map((offers, index) => (
          <div className="mb-5" key={index}>
            <div className="offers card-deck mb-4">
              {offers.map((offer) => (
                <OfferExampleCard key={offer.pageDetailPosition} title={offer.title}>
                  <OfferExampleDetail offer={offer}/>

                  <PlusCircle
                    className="plus-circle d-block d-lg-none position-absolute"
                    onClick={() => this.openModal(offer)}
                    size={30}
                  />
                </OfferExampleCard>
              ))}
            </div>
            {ctas.length > index ? ctas[index] : ''}
          </div>
        ))}
      </section>
    </DefaultLayout>;
  }
}

export default connect(
  (state) => ({}),
  (dispatch) => ({
    redirectToNotFound: () => dispatch(redirectToNotFound())
  })
)(connectModal({OfferExampleModal}, OffersExamples));